<template>
  <div
    :class="{
      content: true,
      page: page.total > queryParams.Limit
    }"
    ref="content"
  >
    <div class="main-content">
      <div class="search-box" ref="search">
        <a-form>
          <a-row>
            <a-col :sm="5">
               <e-input
                title="标题"
                :labelCol="6"
                :valueCol="16"
                v-model:value="queryParams.Name"
              />
            </a-col>
            <a-col :sm="8" :lg="6">
              <a-button type="primary" @click="getDataList(1)">查询</a-button>
              <a-button
                type="primary"
                @click="reset(() => resetFun())"
                danger
                style="margin-left: 10px"
              >
                重置
              </a-button>
              <a-button
                type="primary"
                style="margin-left: 10px"
                @click="addForm(() => $refs.eForm.open(null))"
              >
                添加权限
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="data-list">
        <a-table
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :loading="loading"
          :row-key="record => record.id"
          :scroll="{ y: height, x: width }"
        >
        <template #bodyCell="{ column, record, index }">
<template v-if="column.key === 'index'">
            {{ (page.page - 1) * queryParams.Limit + index + 1 }}
          </template>

          <template v-if="column.key === 'actionlist'">
            <span v-for="(v, k) in record.actions" :key="k">
              <a-tag color="orange">{{ v.name }}</a-tag>
            </span>
          </template>

          <template v-if="column.key === 'sort'">
            <a-tooltip>
              <template #title>修改顺序</template>
              <a @click.stop="editSort(record)">
                <a-tag color="blue">{{ record.sort }}</a-tag>
              </a>
            </a-tooltip>
          </template>

          <template v-if="column.key === 'action'">
            <a-tooltip>
              <template #title>添加操作权限</template>
              <a @click.stop="editForm(() => $refs.eActions.open(record))">
                <ApartmentOutlined />
              </a>
            </a-tooltip>
            <a-divider type="vertical" />
            <a-tooltip>

              <template #title>编辑</template>
              <a @click.stop="editForm(() => $refs.eForm.open(record))">
                <EditOutlined />
              </a>
            </a-tooltip>
          </template>
        </template>

        </a-table>
      </div>
    </div>

    <div class="pagination">
      <a-pagination
        :total="page.total"
        v-model:page-size="queryParams.Limit"
        :hide-on-single-page="true"
        :show-size-changer="true"
        :page-size-options="['20', '40', '100', '200']"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
      >
        <template #itemRender="{ page, type }">
          <a v-if="type === 'prev'" class="ant-pagination-item-link">上一页</a>
          <a v-else-if="type === 'next'" class="ant-pagination-item-link">
            下一页
          </a>
          <span v-else>{{ page }}</span>
        </template>
      </a-pagination>
      <span>数据总数：{{ page.total }}</span>
    </div>

    <e-form ref="eForm" @ok="okForm" />
    <e-sort ref="eSort" @ok="okSort" />
    <e-actions ref="eActions" @close="getDataList(page.page)" />
  </div>
</template>

<script>
import { defineComponent, ref, createVNode } from 'vue'
import {
  EditOutlined,
  ApartmentOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons-vue'
import { MenuClass } from '@/apis/menu'
import page from '@/mixins/page'
import EForm from '@/components/forms/menu/Form'
import EActions from '@/components/forms/menu/Actions'
import ESort from '@/components/forms/Sort'

const api = new MenuClass()
export default defineComponent({
  mixins: [page],
  components: {
    EForm,
    EActions,
    ESort,
    EditOutlined,
    ApartmentOutlined
  },
  setup () {
    const loading = ref(false)
    const height = ref(500)
    const width = ref(500)
    const id = ref(0)

    const columns = [
      {
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 60
      },
      {
        title: '标题',
        dataIndex: 'name',
        key: 'name',
        width: 120
      },
      {
        title: '标识',
        dataIndex: 'sign',
        key: 'sign',
        width: 250
      },
      {
        title: '操作权限',
        dataIndex: 'actionlist',
        key: 'actionlist'
      },
      {
        title: '顺序',
        dataIndex: 'sort',
        key: 'sort',
        width: 100
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 100
      }
    ]
    return {
      columns,
      loading,
      height,
      width,
      id
    }
  },
  created () {
    this.getDataList(1)
  },
  methods: {
    getDataList (page) {
      this.loading = true
      this.page.page = page
      const q = { ...this.queryParams }
      q.Offset = (page - 1) * q.Limit

      api.gets(q).then(resp => {
        this.list = resp.data
        this.page.total = resp.total
        this.loading = false
        this.getTableHeight()
      })
    },
    resetFun () {
      this.queryParams = {
        Limit: 20
      }

      this.getDataList(1)
    },
    delFormFun (record) {
      const _this = this
      _this.$confirm({
        title: '确定删除?',
        icon: createVNode(ExclamationCircleOutlined),
        content: createVNode(
          'div',
          {
            style: 'color:red;'
          },
          `即将删除数据：${record.name}`
        ),

        onOk () {
          api.del(record.id).then(() => {
            _this.$message.success('删除成功！')
            _this.getDataList(1)
          })
        }
      })
    },
    okSort (e) {
      if (this.id !== 0) {
        api.sort(this.id, e).then(() => {
          this.$message.success('修改成功')
          this.$refs.eSort.handleClose()
          this.id = 0
          this.getDataList(this.page.page)
        })
      }
    },

    editSort (record) {
      this.id = record.id
      this.$refs.eSort.open(record.sort)
    },
    getTableHeight () {
      const paddingBottom = this.page.total > this.queryParams.Limit ? 50 : 9
      const mainPadding = 30
      const thead = 56
      this.height =
        this.$refs.content.offsetHeight -
        this.$refs.search.offsetHeight -
        thead -
        paddingBottom -
        mainPadding

      this.width = this.$refs.search.offsetWidth - 10
    },

    okForm () {
      this.getDataList(1)
    }
  }
})
</script>

<style lang="less" scoped>
.username {
  display: flex;
  align-items: center;
  img {
    display: block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    border: 1px solid #ccc;
  }
  span {
    margin-left: 5px;
    &.sex {
      font-size: 12px;
      color: #ccc;
      &.man {
        color: rgb(66, 48, 228);
      }
      &.feman {
        color: rgb(228, 48, 48);
      }
    }
  }
}
</style>
